var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fields-module" },
    [
      _vm.showNextTemplateButton || _vm.selectedInstanceIndex
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between mb-3" },
            [
              _c(
                "b-button-group",
                { attrs: { size: "sm" } },
                [
                  _vm.showNextTemplateButton
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              return _vm.moveInstanceSelection(1)
                            },
                          },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "arrow-down" } }),
                          _vm._v("\n        Next template\n      "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedInstanceIndex
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function ($event) {
                              return _vm.moveInstanceSelection(-1)
                            },
                          },
                        },
                        [
                          _vm._v("\n        Prev template\n        "),
                          _c("b-icon", { attrs: { icon: "arrow-up" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.totalTemplateOrder) +
                    "/" +
                    _vm._s(_vm.totalTemplatesCount)
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "textEditorFieldsSection")
                },
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.textEditorFieldsSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.textEditorFieldsSection } },
                [
                  _c(
                    "div",
                    _vm._l(_vm.textFields, function (field, index) {
                      return _c(
                        "b-form-group",
                        {
                          key: `${field.element_id}_${index}`,
                          attrs: { "label-for": `field_${field.id}` },
                        },
                        [
                          _c(
                            "FormGroupCharLimit",
                            {
                              attrs: {
                                label: field.name,
                                value:
                                  _vm.selectedInstance.data[field.element_id],
                                max: _vm.getMaxCharsValue(field),
                              },
                            },
                            [
                              _c(
                                field.type === "Multi Line Text" &&
                                  String(
                                    _vm.selectedInstance?.data?.[
                                      field.element_id
                                    ] ?? ""
                                  ).includes("\n")
                                  ? "b-textarea"
                                  : "b-input",
                                {
                                  tag: "component",
                                  attrs: {
                                    id: `field_${field.element_id}`,
                                    value:
                                      _vm.selectedInstance.data[
                                        field.element_id
                                      ],
                                  },
                                  on: {
                                    focus: function ($event) {
                                      return _vm.setActiveObject(field)
                                    },
                                    input: function ($event) {
                                      return _vm.updateField(field, $event)
                                    },
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    blur: _vm.onBlurText,
                                  },
                                }
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.shouldShowThisField(field)
                            ? _c(
                                "div",
                                { staticClass: "d-flex align-items-baseline" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "mt-1 btn-sm w-50 maintain-button-width",
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.redraw(field)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v("\n                Align to "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            JSON.parse(field.options).Option1
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-checkbox",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: false,
                                          expression: "false",
                                        },
                                      ],
                                      staticClass: "ml-1 w-40",
                                      attrs: {
                                        checked:
                                          _vm.getAutoPositionValue(field),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onChangeAutoPositionValue(
                                            field,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Auto position\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "translateFieldsSelection")
                },
              },
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.translateFieldsSelection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.translateFieldsSelection } },
                [
                  _c(
                    "div",
                    [
                      _vm.textFields.length === 0
                        ? _c("b-form-group", [
                            _vm._v(
                              "\n            This template has no text fields\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.textFields.length > 0
                        ? _c(
                            "b-form-group",
                            { staticClass: "translation-form-group" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("Multiselect", {
                                    staticClass:
                                      "flex-grow-1 form-control px-1 py-0 font-base flex items-center ms-bootstrap-size",
                                    staticStyle: {
                                      width: "auto !important",
                                      height: "auto !important",
                                    },
                                    attrs: {
                                      options: _vm.languages,
                                      multiple: true,
                                      "close-on-select": false,
                                      "clear-on-select": false,
                                      placeholder: "Choose language(s)...",
                                    },
                                    model: {
                                      value: _vm.translateTargetLanguages,
                                      callback: function ($$v) {
                                        _vm.translateTargetLanguages = $$v
                                      },
                                      expression: "translateTargetLanguages",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.translateTargetLanguages.length <= 1
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "flex-shrink-0 w-100 mt-2",
                                          on: { click: _vm.translate },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Translate\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "flex-shrink-0 w-100 mt-2",
                                      on: { click: _vm.copyAndTranslate },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Copy Template & Translate"),
                                      ]),
                                      _vm._v(" "),
                                      _vm.translateTargetLanguages.length > 1
                                        ? _c(
                                            "b-badge",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { variant: "dark" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.translateTargetLanguages
                                                      .length
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.translateTargetLanguages.length <= 1
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "flex-shrink-0 w-100 mt-2",
                                          on: {
                                            click: _vm.copyFieldsAndTranslate,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Copy Fields & Translate\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("TranslateImageButton", {
                        attrs: {
                          "target-languages": _vm.translateTargetLanguages,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "backgroundFieldsSection")
                },
              },
            },
            [
              _vm._m(2),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.backgroundFieldsSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.backgroundFieldsSection } },
                [
                  _c(
                    "div",
                    [
                      _c("b-form-group", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center flex-column",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "colors-item d-flex justify-content-between align-items-center",
                              },
                              [
                                _c("label", { staticClass: "mb-1" }, [
                                  _c(
                                    "strong",
                                    { staticStyle: { color: "#209c86" } },
                                    [_vm._v("Color")]
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.editor?.colors,
                                  function (color, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "d-flex align-items-center",
                                      },
                                      [
                                        _c("b-input", {
                                          staticClass:
                                            "color-fill-item w-10 no-right-border custom-color-picker",
                                          attrs: {
                                            debounce: "50",
                                            type: "color",
                                          },
                                          on: { update: _vm.redrawBackground },
                                          model: {
                                            value: _vm.editor.colors[index],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editor.colors,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "editor.colors[index]",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("b-input", {
                                          staticClass: "w-100 no-left-border",
                                          staticStyle: { height: "38px" },
                                          attrs: { type: "text" },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onInputColor(
                                                $event,
                                                index
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.editor.colors[index],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editor.colors,
                                                index,
                                                $$v
                                              )
                                            },
                                            expression: "editor.colors[index]",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-row align-items-center mb-1 position-relative w-100",
                                staticStyle: { "margin-top": "10px" },
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "mb-0 mr-2",
                                    staticStyle: { "min-width": "91.5px" },
                                  },
                                  [
                                    _c(
                                      "strong",
                                      { staticStyle: { color: "#209c86" } },
                                      [_vm._v("Image")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-row justify-content-between flex-grow-1 image-multiselect",
                                    class: { "drag-over": _vm.isDragOver },
                                    on: {
                                      dragenter: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onDragEnter.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      dragover: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onDragOver.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      drop: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onDrop.apply(null, arguments)
                                      },
                                    },
                                  },
                                  [
                                    _c("Multiselect", {
                                      staticClass:
                                        "background-dropdown flex-grow-1",
                                      attrs: {
                                        "track-by": "id",
                                        label: "name",
                                        placeholder: "",
                                        options: _vm.getBackgroundFields,
                                      },
                                      on: {
                                        close: _vm.onBlurText,
                                        open: _vm.getFields,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "singleLabel",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "background-dropdown-label",
                                                  on: {
                                                    mouseenter: function (
                                                      $event
                                                    ) {
                                                      _vm.hoveredTag = true
                                                    },
                                                    mouseleave: function (
                                                      $event
                                                    ) {
                                                      _vm.hoveredTag = null
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "background-dropdown-label__image",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "preview-img",
                                                        attrs: {
                                                          src: props.option
                                                            .thumbnail,
                                                          alt: props.option
                                                            .name,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            $event.preventDefault()
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "option",
                                          fn: function (props) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "background-dropdown-option",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "background-dropdown-option__image",
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: props.option
                                                            .thumbnail,
                                                          alt: props.option
                                                            .name,
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "background-dropdown-option__text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            props.option.name
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "caret",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "custom-arrow" },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "20",
                                                        height: "20",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "#333",
                                                        "stroke-width": "2",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                      },
                                                    },
                                                    [
                                                      _c("polyline", {
                                                        attrs: {
                                                          points:
                                                            "6 9 12 15 18 9",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.selectedBackground,
                                        callback: function ($$v) {
                                          _vm.selectedBackground = $$v
                                        },
                                        expression: "selectedBackground",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "upload-button d-flex align-items-center justify-content-center",
                                        attrs: { variant: "outline-primary" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.onChange(
                                              "selectBackground",
                                              "Replace"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "upload" },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit(
                    "toggleSection",
                    "productImagesFieldsSection"
                  )
                },
              },
            },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("b-icon", {
                attrs: {
                  icon: _vm.isOpen.productImagesFieldsSection
                    ? "chevron-up"
                    : "chevron-down",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.productImagesFieldsSection } },
                [
                  _c(
                    "div",
                    { staticClass: "scroll-images-section" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap align-items-center",
                          class: { "drag-over": _vm.isDragOverProductImages },
                          on: {
                            dragenter: function ($event) {
                              $event.preventDefault()
                              return _vm.onDragEnterProductImages.apply(
                                null,
                                arguments
                              )
                            },
                            dragover: function ($event) {
                              $event.preventDefault()
                              return _vm.onDragOverProductImages.apply(
                                null,
                                arguments
                              )
                            },
                            dragleave: function ($event) {
                              $event.preventDefault()
                              return _vm.onDragLeaveProductImages.apply(
                                null,
                                arguments
                              )
                            },
                            drop: function ($event) {
                              $event.preventDefault()
                              return _vm.onDropProductImage.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _vm._l(_vm.getProductImages, function (image, index) {
                            return _c(
                              "div",
                              {
                                key: `product_image_${
                                  image.templateFieldId ?? image.id ?? "na"
                                }_${index}`,
                                staticClass:
                                  "label-option general-card-template product-card-template",
                                class: {
                                  selected: _vm.layoutTarget?.id === image.id,
                                },
                                on: {
                                  drop: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return ((e) =>
                                      _vm.onDropReplaceProductImage(
                                        e,
                                        image
                                      )).apply(null, arguments)
                                  },
                                  dragover: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "close-btn",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleProductDelete(image)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "bi bi-trash3" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName:
                                          "v-b-tooltip.hover.viewport.noninteractive",
                                        value: "Replace image",
                                        expression: "'Replace image'",
                                        modifiers: {
                                          hover: true,
                                          viewport: true,
                                          noninteractive: true,
                                        },
                                      },
                                    ],
                                    staticClass: "replace-image-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleProductDropdown(
                                          image,
                                          "replace"
                                        )
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "bi bi-repeat" })]
                                ),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "image-option",
                                  attrs: {
                                    src: image.thumbnail,
                                    alt: image.name,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.setActiveObject(image)
                                    },
                                  },
                                }),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center additional-card-template",
                              staticStyle: { width: "60px", height: "60px" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleProductDropdown(null, "add")
                                },
                              },
                            },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                staticClass: "fas fa-plus-circle add-icon",
                                attrs: { title: "Add product images" },
                              }),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.isDisplayedProductImagesSection
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.top",
                                  modifiers: { hover: true, top: true },
                                },
                              ],
                              staticClass:
                                "upload-button d-flex align-items-center justify-content-center",
                              attrs: {
                                title: "Replace product images",
                                variant: "outline-primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleProductDropdown(
                                    null,
                                    "replace_all"
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "bi bi-repeat add-icon" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    "margin-right": "10px",
                                  },
                                },
                                [_c("strong", [_vm._v("Replace")])]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-sidebar-section" },
        [
          _c(
            "div",
            {
              staticClass: "layout-sidebar-section-title",
              on: {
                click: function ($event) {
                  return _vm.$emit("toggleSection", "imagesFieldSection")
                },
              },
            },
            [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                [
                  !_vm.textImagesClassified && _vm.getImages.length > 0
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mr-2 detect-text-btn",
                          attrs: {
                            size: "sm",
                            variant: "outline-primary",
                            disabled: _vm.isClassifyingTextImages,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleDetectTextImages.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _vm.isClassifyingTextImages
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _c("i", { staticClass: "bi bi-fonts" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v("Detect Text"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-icon", {
                    attrs: {
                      icon: _vm.isOpen.imagesFieldSection
                        ? "chevron-up"
                        : "chevron-down",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "transition",
            [
              _c(
                "b-collapse",
                { attrs: { visible: _vm.isOpen.imagesFieldSection } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "scroll-images-section",
                      on: {
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.onDropAddImage.apply(null, arguments)
                        },
                        dragover: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap align-items-center" },
                        [
                          _vm._l(_vm.getImagesWithUuid, function (image) {
                            return _c(
                              "div",
                              {
                                key: image._uuid,
                                staticClass:
                                  "label-option general-card-template image-card-template",
                                class: {
                                  selected: _vm.layoutTarget?.id === image.id,
                                },
                                on: {
                                  drop: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return ((e) =>
                                      _vm.onDropReplaceLayoutImage(
                                        e,
                                        image
                                      )).apply(null, arguments)
                                  },
                                  dragover: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                !_vm.loaded
                                  ? _c(
                                      "div",
                                      { staticClass: "image-loader" },
                                      [
                                        _c("b-spinner", {
                                          attrs: { small: "" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "image-option",
                                  class: { "is-loading": !_vm.loaded },
                                  attrs: {
                                    src: image.thumbnail,
                                    alt: image.name,
                                  },
                                  on: {
                                    load: _vm.onImageLoad,
                                    error: _vm.onImageLoad,
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.setActiveObject(image)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "close-btn",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.handleImageDelete(image)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "bi bi-trash3" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName:
                                          "v-b-tooltip.hover.viewport.noninteractive",
                                        value: "Replace image",
                                        expression: "'Replace image'",
                                        modifiers: {
                                          hover: true,
                                          viewport: true,
                                          noninteractive: true,
                                        },
                                      },
                                    ],
                                    staticClass: "replace-image-btn",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                        return _vm.replaceImage(
                                          image,
                                          "selectBackground",
                                          "Replace",
                                          null,
                                          _vm.selectImageOpenSources
                                            .FIELDS_REPLACE_IMAGE
                                        )
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "bi bi-repeat" })]
                                ),
                                _vm._v(" "),
                                _vm.isTextOnlyImage(image)
                                  ? _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName:
                                              "v-b-tooltip.hover.viewport.noninteractive",
                                            value: "Convert to editable text",
                                            expression:
                                              "'Convert to editable text'",
                                            modifiers: {
                                              hover: true,
                                              viewport: true,
                                              noninteractive: true,
                                            },
                                          },
                                        ],
                                        staticClass: "convert-text-btn",
                                        attrs: {
                                          disabled:
                                            _vm.convertingImageId === image.id,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.handleConvertToText(
                                              image
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.convertingImageId === image.id
                                          ? _c("b-spinner", {
                                              attrs: { small: "" },
                                            })
                                          : _c("i", {
                                              staticClass: "bi bi-fonts",
                                            }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center additional-card-template",
                              on: {
                                click: function ($event) {
                                  return _vm.addAdditionalField(
                                    "Background Theme Image",
                                    null,
                                    _vm.selectImageOpenSources.FIELDS_ADD_IMAGES
                                  )
                                },
                              },
                            },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                staticClass: "fas fa-plus-circle add-icon",
                                attrs: { title: "Add images" },
                              }),
                              _vm._v(" "),
                              _vm.getImages.length > 0
                                ? _c("i", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    staticClass: "bi bi-repeat add-icon",
                                    staticStyle: { "margin-left": "7px" },
                                    attrs: { title: "Replace images" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.replaceAllImage(
                                          "selectBackground",
                                          "Replace"
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "position-fixed apply-to-section" },
        [
          _c(
            "b-form-group",
            [
              _c("span", [_vm._v("Apply to:")]),
              _vm._v(" "),
              _c("SelectTemplateDropdown", {
                staticClass: "d-inline",
                attrs: {
                  "local-storage-key":
                    _vm.LOCAL_STORAGE_KEY_SELECTED_TEMPLATES_FOR_TEXT,
                  "clear-local-storage": false,
                  "show-apply-button": true,
                },
                on: { apply: _vm.confirmApply },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ProductImageDropdown", {
        ref: "productImageDropdownFields",
        attrs: {
          "is-tab-active": false,
          "is-file-image":
            _vm.options.isFileImage || _vm.options.isProductImageObjects,
          "is-fields-tab": true,
        },
        on: {
          input: function ($event) {
            return _vm.onChange("productImage", _vm.fileNameIds)
          },
          uploadInput: (fileIds) =>
            _vm.onChange("productImage", {
              productIds: fileIds,
              type: "uploaded_product_image",
            }),
        },
        model: {
          value: _vm.fileNameIds,
          callback: function ($$v) {
            _vm.fileNameIds = $$v
          },
          expression: "fileNameIds",
        },
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("SelectAllObjectsButton", {
        on: {
          unselected: function ($event) {
            return _vm.$emit("unselected")
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover.viewport.noninteractive",
              value: _vm.pasted ? "Pasted!" : "Paste element",
              expression: "pasted ? 'Pasted!' : 'Paste element'",
              modifiers: { hover: true, viewport: true, noninteractive: true },
            },
          ],
          attrs: { "data-action": "paste", variant: "primary" },
          on: { click: _vm.pasteElement },
        },
        [
          _c("i", {
            class: [
              "cursor-pointer font-xl px-2 bi",
              _vm.pasted ? "bi-check2" : "bi-clipboard",
            ],
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("i", { staticClass: "bi bi-fonts green-fonts" }),
      _vm._v(" "),
      _c("strong", [_vm._v(" Text Content")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("i", { staticClass: "bi bi-translate green-fonts" }),
      _vm._v(" "),
      _c("strong", [_vm._v(" Translate")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("i", { staticClass: "bi bi-palette green-fonts" }),
      _vm._v(" "),
      _c("strong", [_vm._v(" Background")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("i", { staticClass: "bi bi-file-earmark-image green-fonts" }),
      _vm._v(" "),
      _c("strong", [_vm._v(" Product Images")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("i", { staticClass: "bi bi-card-image green-fonts" }),
      _vm._v(" "),
      _c("strong", [_vm._v("Images")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }